/* @flow */
import React, { useContext, memo } from 'react'
import S from './RSVP2.styled'
import RSVP2Card from './RSVP2.card'
import { EditingContext } from '@contexts'
import useEventRegistration from '@website/common/hooks/useEventRegistration'
import RSVPForm from '@website/common/components/RSVPForm'
import RSVPRegistrationPopup from '@website/common/components/RSVPRegistrationPopup'

const RSVP2 = memo(props => {
  const {
    data: {
      subtitleAlignment,
      dateAlignment,
      locationAlignment,
      paragraphAlignment,
      cardImage,
      centerImage,
      titleAlignment,
      titleTextGradient,
      backgroundImgUrl,
      bgOverlayTransparency,
      backgroundImgDimensions
    },
    eventData,
    uniqId
  } = props

  const eventCardMetaData = {
    cardImage,
    centerImage,
    dateAlignment,
    locationAlignment,
    subtitleAlignment,
    titleAlignment,
    titleTextGradient,
    bgOverlayTransparency,
    paragraphAlignment
  }

  const { isEditing } = useContext(EditingContext)
  const {
    onClick: onRSVPBtnClick,
    isLoading,
    additionalGuestCount,
    isRegistrationClosedPopupOpen,
    closeRegistrationClosedPopup,
    setGuestLimit
  } = useEventRegistration(eventData.id, eventData.form.additionalGuestNumber)

  const registrationClosedPopupData = eventData.popups.closed

  return (
    <S.ComponentWrapper>
      <S.StyledContainer
        isEditing={isEditing}
        backgroundImgUrl={backgroundImgUrl}
        backgroundImgDimensions={backgroundImgDimensions}
        bgOverlayTransparency={bgOverlayTransparency}
      >
        <S.WmCustomContainer>
          <RSVP2Card
            detailsData={eventData.details}
            metaData={eventCardMetaData}
            onRSVPBtnClick={onRSVPBtnClick}
            isLoading={isLoading}
            titleTextGradient={titleTextGradient}
          />
        </S.WmCustomContainer>
      </S.StyledContainer>
      <RSVPForm
        compId={uniqId}
        eventId={eventData.id}
        formData={eventData.form}
        popupsData={eventData.popups}
        detailsData={eventData.details}
        additionalGuestCount={additionalGuestCount}
        setGuestLimit={setGuestLimit}
      />
      {!isEditing ? (
        <RSVPRegistrationPopup
          isPopupOpen={isRegistrationClosedPopupOpen}
          title={registrationClosedPopupData.title.text}
          paragraph={registrationClosedPopupData.paragraph.text}
          onClose={closeRegistrationClosedPopup}
        />
      ) : null}
    </S.ComponentWrapper>
  )
})

export default RSVP2
